import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as CategoryIcon } from "../assets/icons/category.svg";
import "../webmenulinks.css";

export default function WebMenuLinks(props) {
  const { toggle, pathname, userInfo } = props;
  return (
    <ul
      className="nav nav-pills flex-column mb-auto menu-list"
      style={{ flexWrap: "nowrap", padding: 0 }}
    >
      <li className="menu-item">
        <Link
          to="/category/order"
          className={
            pathname === "/category/order"
              ? "nav-link webmenu  active"
              : "nav-link webmenu "
          }
        >
          <i className="fas fa-home"></i>
        </Link>
      </li>
      {userInfo.isHelpDesk && !userInfo.client && (
        <li className="menu-item">
          <Link
            to="/admin/business-list"
            className={
              pathname === "/admin/business-list"
                ? "nav-link webmenu  active"
                : "nav-link webmenu "
            }
          >
            <Row className="nowrap">
              <Col md={2}>
                <i className="fas fa-user-tie"></i>
              </Col>
              {toggle && <Col md={10}> Üyelikler</Col>}
            </Row>
          </Link>
        </li>
      )}
      {userInfo.isHelpDesk && !userInfo.client && (
        <li className="menu-item">
          <Link
            to="/admin/category-samples"
            className={
              pathname === "/admin/category-samples"
                ? "nav-link webmenu  active"
                : "nav-link webmenu "
            }
          >
            <Row className="nowrap">
              <Col md={2}>
                <CategoryIcon size="24" fill="white" />
              </Col>
              {toggle && <Col md={10}> Kategori Havuzu</Col>}
            </Row>
          </Link>
        </li>
      )}

      {userInfo.isHelpDesk && !userInfo.client && (
        <>
          <li className="menu-item">
            <Link
              to="/admin/product-samples"
              className={
                pathname === "/admin/product-samples"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-gift"></i>
                </Col>
                {toggle && <Col md={10}> Ürün Havuzu</Col>}
              </Row>
            </Link>
          </li>
          <li className="menu-item">
            <Link
              to="/admin/tabletype-samples"
              className={
                pathname === "/admin/tabletype-samples"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-chair"></i>
                </Col>
                {toggle && <Col md={10}> Masa Tipi Havuzu</Col>}
              </Row>
            </Link>
          </li>
          <li className="menu-item">
            <Link
              to="/admin/business-user-stats"
              className={
                pathname === "/admin/business-user-stats"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-terminal"></i>
                </Col>
                {toggle && <Col md={10}> İşletme Logları</Col>}
              </Row>
            </Link>
          </li>
        </>
      )}
      {((userInfo.isHelpDesk && userInfo.client) || !userInfo.isHelpDesk) && (
        <>
          <li className="menu-item">
            <Link
              to="/admin/expenses"
              className={
                pathname === "/admin/expenses"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-money-bill-wave"></i>
                </Col>
                {toggle && <Col md={10}> Giderler</Col>}
              </Row>
            </Link>
          </li>

          <li className="menu-item">
            <Link
              to="/reportsummary"
              className={
                pathname === "/reportsummary"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fa fa-line-chart"></i>
                </Col>
                {toggle && (
                  <Col md={10} className="whitespacenowrap">
                    {" "}
                    Raporlar
                  </Col>
                )}
              </Row>
            </Link>
          </li>

          <li className="menu-item">
            <Link
              to="/admin/orders-filter"
              className={
                pathname === "/admin/orders-filter"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-search"></i>
                </Col>
                {toggle && <Col md={10}> Siparişlerde Ara</Col>}
              </Row>
            </Link>
          </li>

          <li className="menu-item">
            <Link
              to="/order/touch"
              className={
                pathname === "/order/touch"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-hand-pointer-o"></i>
                </Col>
                {toggle && <Col md={10}> Dokunmatik</Col>}
              </Row>
            </Link>
          </li>

          <li className="menu-item">
            <Link
              to="/admin/management"
              className={
                pathname === "/admin/management"
                  ? "nav-link webmenu  active"
                  : "nav-link webmenu "
              }
            >
              <Row className="nowrap">
                <Col md={2}>
                  <i className="fas fa-store"></i>
                </Col>
                {toggle && <Col md={10}> Mağaza Yönetimi</Col>}
              </Row>
            </Link>
          </li>
        </>
      )}
    </ul>
  );
}
